module.exports = __webpack_public_path__ + "static/img/far1.f68b1e3b.png";